// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 442) return "static/chunks/442-95c4d553f33a219f.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"498":"184c0950da14f370","818":"548ca1308401c6dd","849":"dbd0f50edfbfc992","868":"a38042724fd5fa64"}[chunkId] + ".js";
};